import { render } from "./safe_custody.vue?vue&type=template&id=469138fd"
import script from "./safe_custody.vue?vue&type=script&lang=js"
export * from "./safe_custody.vue?vue&type=script&lang=js"

import "./safe_custody.vue?vue&type=style&index=0&id=469138fd&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__